import { SVGProps } from 'react';

export default function CircleCheckIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icons / 16px /circle-check">
        <path id="Icon" d="M8.50016 2.66634C5.55464 2.66634 3.16683 5.05416 3.16683 7.99967C3.16683 10.9452 5.55464 13.333 8.50016 13.333C11.4457 13.333 13.8335 10.9452 13.8335 7.99967C13.8335 5.05416 11.4457 2.66634 8.50016 2.66634ZM1.8335 7.99967C1.8335 4.31778 4.81826 1.33301 8.50016 1.33301C12.1821 1.33301 15.1668 4.31778 15.1668 7.99967C15.1668 11.6816 12.1821 14.6663 8.50016 14.6663C4.81826 14.6663 1.8335 11.6816 1.8335 7.99967ZM11.6097 5.83473C11.8849 6.07935 11.9097 6.50073 11.6651 6.77592L8.10955 10.7759C7.98304 10.9182 7.8017 10.9997 7.61127 10.9997C7.42085 10.9997 7.23951 10.9182 7.113 10.7759L5.33522 8.77592C5.09061 8.50073 5.1154 8.07935 5.39059 7.83474C5.66578 7.59012 6.08716 7.61491 6.33177 7.8901L7.61127 9.32954L10.6686 5.8901C10.9132 5.61491 11.3346 5.59012 11.6097 5.83473Z" fill={fill ?? 'white'} />
      </g>
    </svg>
  );
}
